// CWI CODE 200
if (document.querySelector(".marquee-swiper")) {
  const swiper = new Swiper(".marquee-swiper", {
    spaceBetween: 0,
    speed: 5000, 
    autoplay: {
      delay: 0,
      disableOnInteraction: false, 
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
  });
}

// CW CODE C01
if (document.querySelectorAll(".breath_care_uoter .images_slider").length) {
  document.querySelectorAll(".breath_care_uoter .images_slider").forEach((videoBannerSlider) => {
    const parent = videoBannerSlider.closest(".breath_care_uoter");

    const Video_banner_Swiper = new Swiper(videoBannerSlider, {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: parent.querySelector(".swiper-button-next"),
        prevEl: parent.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: parent.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
}

// CWI CODE J
const imageSliders = document.querySelectorAll(".image_slider .image_list");

if (imageSliders.length) {
  imageSliders.forEach((banner_slider) => {
    const parentSlider = banner_slider.closest(".image_slider");

    const nextArrow = parentSlider.querySelector(".next_arrow");
    const prevArrow = parentSlider.querySelector(".prev_arrow");
    const paginationEl = parentSlider.querySelector(".banner_dot");

    if(banner_slider.closest('.slider_autoplay')){
      const bannerSwiper = new Swiper(banner_slider, {
        loop: true,
        slidesPerView: 1,
        autoHeight: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });  
    }else{
      const bannerSwiper = new Swiper(banner_slider, {
        loop: true,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }
  });
}

// CWI code 002
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.customer-story-swiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }
    });
  });
  
// CWI code 001
  //  document.addEventListener('DOMContentLoaded', function () {
  //   new Swiper('.block_image_text_inner', {
  //     slidesPerView: 3,
  //     spaceBetween: 30,
  //     loop: true,
  //     // autoplay: {
  //     //   delay: 2000,
  //     // },


  //     breakpoints: {
  //       0: {
  //         slidesPerView: 1,
  //         spaceBetween: 10,
  //       },
  //       749: {
  //         slidesPerView: 2,
  //         spaceBetween: 10,
  //       },
  //       1024: {
  //         slidesPerView: 3
  //       }
  //     }
  //   });
  // });

const Step_Sliders = document.querySelectorAll(".image_with_text_uoter .block_image_text_inner");

if (Step_Sliders.length) {
  Step_Sliders.forEach((step__slider) => {
    const parentSlider = step__slider.closest(".image_with_text_uoter .block_image_text_inner");

    const nextArrow = parentSlider.querySelector(".swiper-button-next");
    const prevArrow = parentSlider.querySelector(".swiper-button-prev");

    const bannerSwiper = new Swiper(step__slider, {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        749: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3
        }
      }      
    });
  });
}

const sliders = document.querySelectorAll(".featured_collection_tab .slider_with_arrow");

if (sliders.length) {
  sliders.forEach((pro_grid_slider) => {
    const parentSlider = pro_grid_slider.closest(".slider_with_arrow");

    const nextArrow = parentSlider.querySelector(".slider-button--next");
    const prevArrow = parentSlider.querySelector(".slider-button--prev");

    const Pro_grid_Swiper = new Swiper(pro_grid_slider, {
      loop: false,
      slidesPerView: 3.5,
      spaceBetween: 16,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        1280: {
          slidesPerView: 4.5,
        },
        990: {
          slidesPerView: 3.5,
        },
        750: {
          slidesPerView: 2.5,
        },
        0: {
          slidesPerView: 1.2,
        },
      },
    });

    document.querySelector(".featured_collection_tab")?.classList.remove("hidden");
  });
}

// CWI CODE N
function product_grid_variant_change(){
    document.querySelectorAll(".product-card-wrapper .change_variant_js").forEach(function(single_variant){
        single_variant.addEventListener("click",function(){
          this.closest(".product-card-wrapper").querySelectorAll(".change_variant_js").forEach(function(single_variant){
            single_variant.classList.remove("active");
          });
          this.classList.add("active");

          var variant_src = this.getAttribute("variant_src"),
              variant_id = this.getAttribute("variant_id"),
              variant_price = this.getAttribute("variant_price");

          if(this.closest(".product-card-wrapper").querySelector("product-form form input.product-variant-id")){
              this.closest(".product-card-wrapper").querySelector("product-form form input.product-variant-id").value = variant_id;
          }
          if(this.closest(".product-card-wrapper").querySelector(".price.update_price_JS .price-item--regular")){
              this.closest(".product-card-wrapper").querySelector(".price.update_price_JS .price-item--regular").innerHTML = variant_price;
          }
          if(this.closest(".product-card-wrapper").querySelector(".media img:first-child")){
              this.closest(".product-card-wrapper").querySelector(".media img:first-child").setAttribute("src",variant_src);
              this.closest(".product-card-wrapper").querySelector(".media img:first-child").setAttribute("srcset",variant_src);
          }
        });
    });
}

product_grid_variant_change();

/* CWI code 001 */
// document.addEventListener("DOMContentLoaded", function() {
//     const swiperEl = document.querySelector('.images_swiper_section .blog_list');

//     if (swiperEl) {
//       new Swiper(swiperEl, {
//         spaceBetween: 30,
//         loop: true,
//         autoplay: {
//           delay: 3000,
//         },

//         navigation: {
//           nextEl: '.swiper-button-next',
//           prevEl: '.swiper-button-prev',
//         },
//         breakpoints: {
//           0: {
//             slidesPerView: 1,
//             spaceBetween: 20
//           },
//           567: {
//             spaceBetween: 15

//           },
//           750: {
//             slidesPerView: 2,
//             spaceBetween: 10

//           },
//           990: {
//             slidesPerView: 3,
//           },
//         },
//       });
//       document.querySelector(".images_swiper_section")?.classList.remove("hidden");      
//     }
//   });
document.addEventListener("DOMContentLoaded", function () {
  const swiperEl = document.querySelector(".images_swiper_section .swiper");

  if (swiperEl) {
    new Swiper(swiperEl, {
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".images_swiper_section .swiper-button-next",
        prevEl: ".images_swiper_section .swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    // Reveal the section once Swiper initializes successfully
    document.querySelector(".images_swiper_section")?.classList.remove("hidden");
  }
});

// ==========================================
// Trost Product Card Quantity / Variant Switcher
// ==========================================
document.addEventListener('click', function(e) {
  var qtyBtn = e.target.closest('.t-qty-btn');
  if (!qtyBtn) return;
  e.preventDefault();
  e.stopPropagation();

  var card = qtyBtn.closest('.t-photo-card') || qtyBtn.closest('.card-wrapper') || qtyBtn.closest('.t-slider-item') || qtyBtn.closest('.product-card-wrapper');
  if (!card) return;

  // 1. Toggle active state
  card.querySelectorAll('.t-qty-btn').forEach(function(b) {
    b.classList.remove('is-active');
  });
  qtyBtn.classList.add('is-active');

  // 2. Update price
  var priceEl = card.querySelector('.t-card-price');
  var newPrice = qtyBtn.getAttribute('data-price');
  if (priceEl && newPrice) {
    priceEl.textContent = newPrice;
  }

  // 3. Update image if variant image exists
  var newImgSrc = qtyBtn.getAttribute('data-image-src');
  if (newImgSrc) {
    var imgEl = card.querySelector('.t-card-img');
    if (imgEl) {
      imgEl.src = newImgSrc;
      imgEl.srcset = newImgSrc;
    }
  }

  // 4. Update Add to Cart button
  var variantId = qtyBtn.getAttribute('data-variant-id');
  var addBtn = card.querySelector('.t-card-add-btn');
  var isAvailable = qtyBtn.getAttribute('data-available') !== 'false';

  if (addBtn && variantId) {
    addBtn.setAttribute('data-variant-id', variantId);
    if (isAvailable) {
      addBtn.removeAttribute('disabled');
      addBtn.classList.remove('is-soldout');
      addBtn.textContent = 'Add to Cart';
    } else {
      addBtn.setAttribute('disabled', 'disabled');
      addBtn.classList.add('is-soldout');
      addBtn.textContent = 'Sold Out';
    }
  }

  // 5. Update card links to point to chosen variant
  if (variantId) {
    card.querySelectorAll('a.t-card-visual, a.t-card-title-link').forEach(function(link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = url.pathname + url.search;
      } catch(err) {}
    });
  }
});

// ==========================================
// Trost Quick Add To Cart
// ==========================================
document.addEventListener('click', function(e) {
  var addBtn = e.target.closest('.trost-quick-add');
  if (!addBtn) return;
  e.preventDefault();
  e.stopPropagation();

  var variantId = addBtn.getAttribute('data-variant-id');
  if (!variantId || addBtn.hasAttribute('disabled')) return;

  var originalHTML = addBtn.innerHTML;
  addBtn.innerHTML = '<span style="font-size:12px; font-weight:600;">Adding...</span>';
  addBtn.setAttribute('disabled', 'disabled');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Network response was not ok');
    return res.json();
  })
  .then(function(item) {
    addBtn.innerHTML = '<span style="font-size:12px; font-weight:600; color:#489b6b;">✓ Added</span>';
    setTimeout(function() {
      addBtn.innerHTML = originalHTML;
      addBtn.removeAttribute('disabled');
    }, 1600);

    // Trigger cart update event for Dawn theme
    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'trost-quick-add' });
    }

    // Update cart drawer / notification if present
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      var cartUrl = window.routes ? window.routes.cart_url : '/cart';
      fetch(cartUrl + '?section_id=cart-drawer')
        .then(function(response) { return response.text(); })
        .then(function(responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var selectors = ['#CartDrawer-ItemCount', '#CartDrawer-CartErrors', '#CartDrawer-CartItems', '#CartDrawer-Subtotal', '#CartDrawer-Discount'];
          selectors.forEach(function(sel) {
            var target = document.querySelector(sel);
            var src = html.querySelector(sel);
            if (target && src) {
              target.innerHTML = src.innerHTML;
            }
          });
          cartDrawer.open();
        })
        .catch(console.error);
    }
  })
  .catch(function(err) {
    console.error(err);
    addBtn.innerHTML = originalHTML;
    addBtn.removeAttribute('disabled');
  });
});


